import React from "react";
import verify from "../../../assets/verified.png";
import { VslTestimonialImages, VslTestimonials } from "../../../constant/data";
import { testimonials } from "../constant/data";
import TestimonialCard from "./testimonialCard";

const Testimonials = () => {
    return (
        <div className="bg-[#F4F5F7]">
            <div className=" mx-auto  px-8 space-y-5 py-12 max-w-7xl">
                <div className="w-full flex items-center justify-center">
                    <div className="w-60 h-4 bg-[#132C4D]" />
                </div>
                <h2 className="font-bold md:text-4xl text-2xl text-center">
                    Real Respoclear Users. Real Life-Changing Results
                </h2>
                <div className="flex flex-wrap justify-center">
                    {VslTestimonialImages.map((image) => (
                        <div
                            key={image.id}
                            className="lg:w-60 lg:h-60 w-48 h-48 shadow-lg border-[6px] border-b-[16px] border-white shadow-custom transform rotate-[-4deg]">
                            <img
                                src={image.src}
                                alt={image.alt}
                                className="w-full lg:h-56 h-48  object-cover"
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* testoonials */}
            <div className="mx-auto max-w-5xl px-4 pb-10 space-y-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                    {testimonials.map((testimonial, index) => (
                        <TestimonialCard key={index} {...testimonial} isOffset={index % 2 !== 0} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Testimonials;
